import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';

import { useEditorDetails } from '../../context';
import {
  defaultAttachmentEditorOption,
  defaultEditorOption,
  EditorOptionMap,
} from '../../PlainEditor/const';
import { MarkState, ToolbarOption, ToolbarProps } from '../../PlainEditor/types';

function Toolbar({
  isMedia,
  classes,
  editorOptions = isMedia ? defaultAttachmentEditorOption : defaultEditorOption,
  hideDivider = false,
  editorOptionMap = EditorOptionMap,
  disabled = false,
}: ToolbarProps) {
  const { onEditorOptionClick, marksActiveMap, uppy, editorView } = useEditorDetails();

  return (
    <Box
      className={cn('justify-self-end xs:hidden', classes?.root, {
        'pointer-events-none': disabled,
      })}
      tabIndex={disabled ? -1 : undefined}>
      {!hideDivider ? <Box className="h-1 w-full bg-divider" /> : null}
      <Stack alignItems="center" className={cn('py-8 px-12', classes?.container)}>
        {editorOptions.map((editorOption, index) => {
          if (editorOption === ToolbarOption.Separator) {
            return (
              <Stack key={index + 'Separator'} className="h-24 border-divider ms-4 me-8 border-s" />
            );
          }

          if (editorOption === ToolbarOption.Spacer) {
            return <Stack key={index + 'Spacer'} className="h-24 flex-grow ms-4 me-8" />;
          }

          const option = editorOptionMap.get(editorOption)!;

          return (
            <option.Component
              key={option.key}
              Icon={option.Icon}
              accept={option.accept}
              blockName={option.blockName}
              className={option.className}
              classes={option.classes}
              editorOption={option.editorOption}
              editorView={editorView}
              isActive={marksActiveMap[option.blockName] === MarkState.Active}
              isHidden={marksActiveMap[option.blockName] === MarkState.Hidden}
              tooltipKey={option.tooltipKey}
              uppy={uppy}
              onClick={onEditorOptionClick}
            />
          );
        })}
      </Stack>
    </Box>
  );
}

export default React.memo(Toolbar);
